import { useState, FormEvent } from 'react';

export default function NewsletterCTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="mobile_alt"]');
    const honeypotVal = honeypot?.value?.trim();

    if (honeypotVal) {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setErrorMsg('请输入有效的邮箱地址');
      setStatus('error');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const formData = new FormData(form);
      formData.delete('mobile_alt');

      const res = await fetch('https://readdy.ai/api/form/d9rh4k4nlsngrm4lmc3g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试';
        if (msg.includes('spam')) {
          setStatus('success');
          setEmail('');
          return;
        }
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查连接后重试');
      setStatus('error');
    }
  };

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20coral%20and%20warm%20amber%20tones%2C%20delicate%20flowing%20shapes%2C%20dreamy%20atmosphere%2C%20paper-like%20texture%2C%20elegant%20minimal%20design%2C%20soft%20lighting&width=1600&height=600&seq=cta-bg-comic-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/85 to-foreground-900/70"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
          订阅琉璃漫站，追更不迷路
        </h2>
        <p className="text-background-50/70 text-base mb-8 max-w-lg mx-auto">
          第一时间获取最新漫画更新通知、独家优惠活动和限时免费阅读资讯
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="mobile_alt"
            className="website-alt-field"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => { setEmail(e.target.value); if (status !== 'idle') setStatus('idle'); }}
            placeholder="输入你的邮箱地址"
            required
            className="w-full sm:flex-1 px-5 py-3.5 rounded-lg bg-background-50/10 border border-background-50/20 text-background-50 placeholder-background-50/40 text-sm focus:outline-none focus:border-primary-400 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap disabled:opacity-60"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>
        {status === 'success' && (
          <p className="mt-4 text-accent-400 text-sm font-medium">订阅成功！感谢你的关注</p>
        )}
        {status === 'error' && errorMsg && (
          <p className="mt-4 text-red-400 text-sm">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}